export const HUMANOID_VIEW_PATH: string = "/campaigns/humanoid";